import { render, staticRenderFns } from "./paymentDetails.vue?vue&type=template&id=c20b7446"
import script from "./paymentDetails.vue?vue&type=script&lang=js"
export * from "./paymentDetails.vue?vue&type=script&lang=js"
import style0 from "./paymentDetails.vue?vue&type=style&index=0&id=c20b7446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports